module.exports = __webpack_public_path__ + "img/paperclip.a2517b8e.svg";